import { API_CONFIG } from '../../config/api';
import { getToken } from '../tokenStorage';

export interface InboxItem {
  id: string;
  type: string;
  title: string;
  preview: string | null;
  read_at: string | null;
  created_at: string;
}

export interface InboxListResponse {
  items: InboxItem[];
  unread_count: number;
  limit: number;
  offset: number;
}

async function authHeaders() {
  const token = await getToken();
  return { 'Content-Type': 'application/json', Authorization: `Bearer ${token}` };
}

export async function getInbox(limit = 20, offset = 0): Promise<InboxListResponse> {
  const url = new URL(`${API_CONFIG.baseURL}/api/v1/inbox`);
  url.searchParams.append('limit', String(limit));
  url.searchParams.append('offset', String(offset));
  const res = await fetch(url.toString(), { method: 'GET', headers: await authHeaders() });
  if (!res.ok) throw new Error('Failed to fetch inbox');
  return res.json();
}

export async function markInboxRead(id: string): Promise<{ unread_count: number }> {
  const res = await fetch(`${API_CONFIG.baseURL}/api/v1/inbox/${id}/read`, {
    method: 'POST',
    headers: await authHeaders(),
  });
  if (!res.ok) throw new Error('Failed to mark inbox item read');
  return res.json();
}

/** Feed header: mark every unread inbox item read (Task-3 endpoint). */
export async function markAllInboxRead(): Promise<{ unread_count: number }> {
  const res = await fetch(`${API_CONFIG.baseURL}/api/v1/inbox/read-all`, {
    method: 'POST',
    headers: await authHeaders(),
  });
  if (!res.ok) throw new Error('Failed to mark inbox read');
  return res.json();
}

export async function getInboxItemHtml(id: string, theme: 'light' | 'dark'): Promise<string> {
  const url = new URL(`${API_CONFIG.baseURL}/api/v1/inbox/${id}/html`);
  url.searchParams.append('theme', theme);
  const res = await fetch(url.toString(), {
    method: 'GET',
    headers: await authHeaders(),
  });
  if (!res.ok) throw new Error('Failed to fetch report');
  return res.text();
}
